export const settingWithdrawAllSelector = (state) =>
  state?.settingWithdrawReducer?.settingWithdrawAll;
